// GENERATED AT BUILD TIME by scripts/gen-environment.sh — do not edit.
// The version committed to git holds local-dev values only.
export const environment = {
  production: true,
  apiUrl: 'https://backend-staging.nikocrm.net/api',
  cognitoUserPoolId: 'us-east-1_Wp1MJv77z',
  cognitoClientId: '332b9ebenvuejesei0vvh2m3vb',
  awsRegion: 'us-east-1',
};
